import { render, staticRenderFns } from "./CusManage.vue?vue&type=template&id=644737de&scoped=true&"
import script from "./CusManage.vue?vue&type=script&lang=js&"
export * from "./CusManage.vue?vue&type=script&lang=js&"
import style0 from "./CusManage.vue?vue&type=style&index=0&id=644737de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644737de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644737de')) {
      api.createRecord('644737de', component.options)
    } else {
      api.reload('644737de', component.options)
    }
    module.hot.accept("./CusManage.vue?vue&type=template&id=644737de&scoped=true&", function () {
      api.rerender('644737de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/CusManage.vue"
export default component.exports